import React from "react";
import PropTypes from "prop-types";

// Маппинг статусов (англ => рус)
const STATUS_LABELS = {
  created: "Менеджер скоро свяжется",
  miscalculation: "Просчитывается",
  сalculated: "Просчитан",
  waiting: "Ожидает оплаты",
  paid: "Оплачен",
  assembling: "В сборке",
  in_transit: "В пути",
  arrived: "Прибыл",
  completed: "Завершён",
  cancelled: "Отменён",
  pending: "В обработке"
};

const OrderStatus = ({ status, large = false }) => {
  const label = STATUS_LABELS[status] || "Неизвестно";

  return (
    <div className={`order-status ${status} ${large ? 'large' : ""}`}>
      {label}
    </div>
  );
};

OrderStatus.propTypes = {
  status: PropTypes.string.isRequired
};

export default OrderStatus;
